export default {"src":"/_next/static/media/arrow-right.584105e9.svg","height":12,"width":16};